import { NovaPluginIds } from "panels/controls/PluginAccessPanel/constants"
import { usePluginState } from "../../usePluginState"
import { useMemo } from "react"

export const usePluginSampleData = (id: NovaPluginIds) => {
    const { pluginsThatSupportSampleData } = usePluginState()

    const plugin = useMemo(
        () => pluginsThatSupportSampleData.find((plugin) => plugin.featureId === id),
        [pluginsThatSupportSampleData, id]
    )

    if (!plugin) throw new Error(`plugin: "${id}" does not support sample data.`)

    return plugin
}
